// extracted by mini-css-extract-plugin
export var card = "SectionCards-module--card--Yhdch";
export var cards = "SectionCards-module--cards--UzqoK";
export var mobileCard = "SectionCards-module--mobileCard--ii3NU";
export var section = "SectionCards-module--section--h5vk+";
export var styleCheckmark = "SectionCards-module--styleCheckmark--y0Tlz";
export var styleConnected = "SectionCards-module--styleConnected--0L8eg";